// /frontend/src/components/layout/Layout.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './Header';
import Footer from './Footer';
import PromotionalPopup from '../common/PromotionalPopup';

const Layout = ({ children }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const location = useLocation();

  // Check if user has seen the popup today (using localStorage)
  const hasSeenPopupToday = useCallback(() => {
    const lastSeen = localStorage.getItem('promotional_popup_last_seen');
    console.log('Last seen popup:', lastSeen);
    
    if (!lastSeen) {
      console.log('User has never seen popup');
      return false;
    }
    
    const today = new Date().toDateString();
    const lastSeenDate = new Date(lastSeen).toDateString();
    
    console.log('Today:', today);
    console.log('Last seen date:', lastSeenDate);
    console.log('Has seen today:', today === lastSeenDate);
    
    return today === lastSeenDate;
  }, []);

  // Mark popup as seen for today
  const markPopupAsSeen = useCallback(() => {
    const timestamp = new Date().toISOString();
    localStorage.setItem('promotional_popup_last_seen', timestamp);
    console.log('Popup marked as seen:', timestamp);
  }, []);

  // Handle close popup with useCallback
  const handleClosePopup = useCallback(() => {
    console.log('Closing popup');
    setIsPopupOpen(false);
    markPopupAsSeen();
  }, [markPopupAsSeen]);

  // Show popup when landing on homepage or main browse pages
  useEffect(() => {
    console.log('=== useEffect triggered ===');
    console.log('Current pathname:', location.pathname);
    console.log('hasSeenPopupToday function:', typeof hasSeenPopupToday);
    
    const shouldShowPopup = () => {
      const isHomePage = location.pathname === '/';
      const isPackagesPage = location.pathname === '/designer-packages';
      
      const hasSeenToday = hasSeenPopupToday();
      
      const shouldShow = (isHomePage || isPackagesPage) && !hasSeenToday;
      
      return shouldShow;
    };

    console.log('Calling shouldShowPopup()...');
    const result = shouldShowPopup();
    console.log('shouldShowPopup() returned:', result);

    if (result) {
      console.log('Setting timer to show popup in 1.5 seconds...');
      // Show popup after a short delay to ensure page is loaded
      const timer = setTimeout(() => {
        console.log('⭐ Timer executed, showing popup!');
        setIsPopupOpen(true);
      }, 1500); // 1.5 second delay

      return () => {
        console.log('Clearing timer');
        clearTimeout(timer);
      };
    } else {
      console.log('❌ Popup should not be shown');
    }
    console.log('=== useEffect end ===');
  }, [location.pathname, hasSeenPopupToday]);


  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        {children}
        <ToastContainer position="top-right" autoClose={5000} />
      </main>
      <Footer />
      
      {/* Promotional Popup */}
      <PromotionalPopup
        isOpen={isPopupOpen}
        onClose={handleClosePopup}
      />
    </div>
  );
};

export default Layout;